"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Wed Aug 22 2018
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var CompetitorPrice_1 = require("../model/CompetitorPrice");

var CompetitorPriceConverter_1 = require("./CompetitorPriceConverter");

var PriceClassificationsBindingConverter_1 = require("./PriceClassificationsBindingConverter");
/**
 * Implementation of {@link CompetitorPriceConverter}.
 *
 * @author RV
 */


var CompetitorPriceConverterImpl =
/*#__PURE__*/
function (_CompetitorPriceConve) {
  _inherits(CompetitorPriceConverterImpl, _CompetitorPriceConve);

  function CompetitorPriceConverterImpl(priceClassificationBindingConverter) {
    var _this;

    _classCallCheck(this, CompetitorPriceConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CompetitorPriceConverterImpl).call(this));
    _this.priceClassificationBindingConverter = priceClassificationBindingConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(CompetitorPriceConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new CompetitorPrice_1.CompetitorPrice(conversions.documentToClassId(source), CompetitorPrice_1.CompetitorPrice.schema.dataUploadId.valueOf(conversions.toClassReferenceId(source.dataUploadId)), conversions.toDate(source.date), conversions.asObjectList(source, 'flags', function (flagsDocument) {
        return _this2.priceClassificationBindingConverter.toObject(flagsDocument, conversions);
      }), CompetitorPrice_1.CompetitorPrice.schema.competitorProductId.valueOf(conversions.toClassReferenceId(source.competitorProductId)), CompetitorPrice_1.CompetitorPrice.schema.siteId.valueOf(conversions.toClassReferenceId(source.siteId)), conversions.toBigNumber(source.value), conversions.asObjectOpt(source, 'regularPrice', conversions.toBigNumber), source.city, source.isFromWebScraping, source.promo, source.sellout);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        dataUploadId: conversions.toDocumentReferenceId(source.dataUploadId),
        date: conversions.fromDate(source.date),
        flags: conversions.asObjectArray(source, 'flags', function (flags) {
          return _this3.priceClassificationBindingConverter.toDocument(flags, conversions);
        }),
        competitorProductId: conversions.toDocumentReferenceId(source.competitorProductId),
        siteId: conversions.toDocumentReferenceId(source.siteId),
        value: conversions.fromBigNumber(source.value),
        regularPrice: conversions.asObjectOpt(source, 'regularPrice', conversions.fromBigNumber),
        city: source.city,
        isFromWebScraping: source.isFromWebScraping,
        promo: source.promo,
        sellout: source.sellout
      });
      return result;
    }
  }]);

  return CompetitorPriceConverterImpl;
}(CompetitorPriceConverter_1.CompetitorPriceConverter);

CompetitorPriceConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [PriceClassificationsBindingConverter_1.PriceClassificationsBindingConverter])], CompetitorPriceConverterImpl);
exports.CompetitorPriceConverterImpl = CompetitorPriceConverterImpl;